import { IconAdd, LogoBinance, LogoBingX, LogoOKX, LogoUniswap, LogoUpbit } from '@/assets';
import useResponsive from '@/hooks/useResponsive';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionExchangePartner = () => {
  const isMobile = useResponsive();
  const { t } = useTranslation();
  return (
    <section className="our-customers">
      <div className="line" />
      <div className="our-customers__left">
        <p className="title">{t('Exchange Partner')}</p>
      </div>
      <div className="our-customers__right">
        {isMobile ? (
          <>
            <div className="row-box-mobile">
              <div className="box-item">
                <LogoOKX />
              </div>
              <div className="box-item">
                <LogoBinance />
              </div>
            </div>
            <div className="row-box-mobile">
              <div className="box-item">
                <LogoBingX />
              </div>
              <div className="box-item">
                <LogoUpbit />
              </div>
            </div>
            <div className="row-box-mobile">
              <div className="box-item">
                <LogoUpbit />
              </div>
              <div className="box-item">
                <IconAdd />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row-box">
              <div className="box-item"></div>
              <div className="box-item">
                <LogoOKX />
              </div>
              <div className="box-item"></div>
              <div className="box-item">
                <LogoBinance />
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
            </div>
            <div className="row-box">
              <div className="box-item"></div>
              <div className="box-item">
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
              <div className="box-item">
                <LogoBingX />
              </div>
              <div className="box-item">
                <LogoUpbit />
              </div>
            </div>
            <div className="row-box">
              <div className="box-item">
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
              <div className="box-item">
                <LogoUniswap />
              </div>
              <div className="box-item">
                <LogoUpbit />
              </div>
              <div className="box-item">
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default React.memo(SectionExchangePartner);
